import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import InfoTip from './ui/InfoTip';

// The "?" next to every mention of the scan minimum. Metered users only: the minimum and its
// examples (billed by the backend's rule) come with their balance.
export default function ScanMinimumInfo() {
  const { t, i18n } = useTranslation('common');
  const { user } = useAuth();
  const usage = user.char_usage;
  const examples = usage.scan_minimum_examples;
  const n = (value) => value.toLocaleString(i18n.language);
  return (
    <InfoTip label={t('scanMinimumHelp.label')}>
      <span className="info-tip-intro">{t('scanMinimumHelp.intro', { min: n(usage.scan_min_chars_per_page) })}</span>
      <span className="info-tip-examples">{t('scanMinimumHelp.examples')}</span>
      <span className="info-tip-line">
        {t('scanMinimumHelp.passport', { read: n(examples.passport_read), billed: n(examples.passport_billed) })}
      </span>
      <span className="info-tip-line">
        {t('scanMinimumHelp.sparse', { read: n(examples.sparse_read), billed: n(examples.sparse_billed) })}
      </span>
      <span className="info-tip-line">
        {t('scanMinimumHelp.mixed', {
          dense: n(examples.mixed_dense_read),
          sparse: n(examples.mixed_sparse_read),
          billed: n(examples.mixed_billed),
        })}
      </span>
    </InfoTip>
  );
}
